<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <a href="javascript: void(0);">Dashboard</a>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">Details</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="dataLoad">
      <div class="col-lg-12">
        <div class="card min-h-350">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="avatar-md mr-3">
                <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20">
                  <i class="bx bx-box"></i>
                </span>
              </div>
              <div class="media-body overflow-hidden">
                <span>{{data.srv_b_code}}</span>
                <h5 class="text-truncate font-size-18 mt-1">{{data.srv_b_name}}</h5>
                <p class="text-muted mb-0">
                  <router-link
                    :to="{name:'cars_model_detail', params: { uuid: data.crs_model_uuid }}"
                  >{{ data.crs_model_name }}</router-link>,
                  <router-link
                    :to="{name:'cars_brand_detail', params: { uuid: data.crs_brand_uuid }}"
                  >{{ data.crs_brand_name }}</router-link>
                </p>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Package Details :</h5>

            <template v-if="data.srv_b_description != '' && data.srv_b_description != null">
              <read-more
                more-str="Read More"
                :text="data.srv_b_description"
                link="#"
                less-str="Read Less"
                :maxChars="800"
              ></read-more>
            </template>
            <p
              class="text-muted" v-else
            >-</p>
          </div>
          <div class="card-footer bg-white border-top">
            <div class="d-flex justify-content-between">
              <div class>
                <h5 class="font-size-14">Price</h5>
                <p class="font-size-16 text-primary mb-0">
                  <b>Rp {{$root.numberWithCommas(data.srv_b_price)}}</b>
                </p>
              </div>
              <div class="text-right">
                <h5 class="font-size-14">Estimate Durations</h5>
                <p class="text-muted mb-0">
                  {{est_time(data.srv_b_time)}}
                  <i class="bx bx-calendar-check ml-1 text-primary"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card min-h-350">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Produk</h4>
              <!-- <button
                type="button"
                class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                @click="getFieldsEdit()"
              >
                <i class="bx bx-edit mr-2"></i> Produk
              </button> -->
            </div>

            <div class="row mt-4" v-if="data.prd_id.length > 0">
              <div class="col-sm-6" v-for="(item, index) in data.prd_id" :key="index">
                <div class="card border">
                  <div class="card-body">
                    <div class="justify-content-between d-flex">
                      <div>
                        <h5 class="mb-1 font-size-15 text-truncate">
                          <router-link
                            :to="{name:'products_detail', params: { uuid: item.prd_uuid }}"
                          >{{ item.prd_name }}</router-link>
                        </h5>
                      </div>
                    </div>
                    <hr />
                    <div class="align-items-center d-flex justify-content-between">
                      <h5 class="font-size-14 mb-0">Stok</h5>
                      <p class="font-size-14 mb-0">
                        <b>{{ item.prd_stock }}</b>
                      </p>
                    </div>
                    <div class="align-items-center d-flex justify-content-between">
                      <h5 class="font-size-14 mb-0">Price</h5>
                      <p class="font-size-14 mb-0">
                        <b>Rp {{ $root.numberWithCommas(item.prd_price) }}</b>
                      </p>
                    </div>
                    <div class="align-items-center d-flex justify-content-between">
                      <h5 class="font-size-14 mb-0">Purchase</h5>
                      <p class="font-size-14 mb-0">
                        <b>Rp {{ $root.numberWithCommas(item.prd_purchase) }}</b>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center w-100 bg-light mt-3 mb-3 h-350" v-else>
              <div class="m-auto text-center mini-stats-wid">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto">
                  <span class="avatar-title">
                    <i class="bx bx-search-alt font-size-2"></i>
                  </span>
                </div>
                <h5 class="mt-3">Produk Tidak Ada</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Paket Servis",
      table_module: "services_bulk",
      alias_table: "srv_b",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      dataLoad: false,
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.dataLoad = true;
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    est_time(arm) {
      var res = "";
      if (arm != null) {
        var arr = arm.split(":");
        res += arr[0] + " Hours ";
        res += arr[1] + " Minutes";
      }
      return res;
    },
  },
};
</script>